(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8136],{

/***/ 19567:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn-nfts",
      function () {
        return __webpack_require__(26228);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 91269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s": function() { return /* binding */ LearnGrid; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/primitives/index.ts + 15 modules
var primitives = __webpack_require__(92902);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@stitches/react/dist/index.mjs
var dist = __webpack_require__(86744);
;// CONCATENATED MODULE: ./components/learn-nfts/styled/index.tsx


const Grid = (0,dist/* styled */.zo)(primitives/* Box */.xu, {
    display: "grid",
    gap: "10px",
    gridTemplateColumns: "repeat(3, 1fr)",
    overflow: "hidden"
});
const LearnTileHeader = (0,dist/* styled */.zo)(primitives/* Box */.xu, {
    padding: "25px 20px 12px",
    fontSize: "16px",
    height: "80px",
    marginBottom: "12px",
    borderBottom: "1px solid #555",
    borderTopLeftRadius: "16px",
    borderTopRightRadius: "16px"
});
const LearnTileSubTitle = (0,dist/* styled */.zo)(primitives/* Box */.xu, {
    width: "100%",
    height: "48px",
    background: "#333",
    padding: "10px 20px 12px",
    borderBottomLeftRadius: "16px",
    borderBottomRightRadius: "16px"
});
const LearnTileContent = (0,dist/* styled */.zo)(primitives/* Box */.xu, {
    padding: "0 20px",
    marginTop: "18px",
    marginBottom: "24px",
    fontSize: "15px",
    color: "#ccc",
    lineHeight: "21px",
    height: "105px",
    textOverflow: "ellipsis",
    wordWrap: "break-word",
    overflow: "hidden"
});

;// CONCATENATED MODULE: ./components/learn-nfts/LearnTile.tsx




const LearnTile = (param)=>{
    let { title , numArticles , articles , color  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
        css: {
            background: "$gray2",
            borderRadius: "16px",
            gap: "$1",
            height: "100%"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LearnTileHeader, {
                css: {
                    background: color
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    css: {
                        color: "white",
                        fontWeight: "900"
                    },
                    style: "h4",
                    ellipsify: true,
                    children: title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LearnTileSubTitle, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                    style: "h6",
                    css: {
                        color: "#ff0",
                        fontWeight: 900
                    },
                    children: [
                        numArticles,
                        " articles"
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LearnTileContent, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    children: articles.map((article)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/learn-nfts" + article.link,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                                    style: {
                                        "@xs": "h6"
                                    },
                                    css: {
                                        cursor: "pointer",
                                        width: "100%",
                                        transition: "0.3s",
                                        "&:hover": {
                                            color: "$crimson10"
                                        }
                                    },
                                    children: [
                                        "• ",
                                        article.title
                                    ]
                                })
                            })
                        }))
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/learn-nfts/LearnGrid.tsx



const LearnGrid = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Grid */.rj, {
            css: {
                gap: 32,
                width: "95%",
                margin: "0 auto",
                "@xs": {
                    gridTemplateColumns: "unset",
                    width: "80%"
                },
                "@sm": {
                    gridTemplateColumns: "repeat(2, 1fr)",
                    width: "95%"
                },
                "@lg": {
                    gridTemplateColumns: "repeat(3, 1fr)",
                    width: "95%"
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LearnTile, {
                        title: "Introduction To NFTs",
                        numArticles: 3,
                        articles: [
                            {
                                title: "How Do NFTs work?",
                                link: "/how-do-nfts-work"
                            },
                            {
                                title: "The History of NFTs",
                                link: "/history-of-nfts"
                            },
                            {
                                title: "What are NFTs",
                                link: "/what-are-nfts"
                            }
                        ],
                        color: "#34b2e5"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LearnTile, {
                        title: "Creating",
                        numArticles: 3,
                        articles: [
                            {
                                title: "How to Create NFTs?",
                                link: "/create-nfts"
                            }
                        ],
                        color: "#d3311a"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LearnTile, {
                        title: "Selling",
                        numArticles: 3,
                        articles: [
                            {
                                title: "The 4 Best Ways to Promote Your NFT",
                                link: "/promote-your-nft"
                            },
                            {
                                title: "How to Value NFT Art?",
                                link: "/value-nft-art"
                            },
                            {
                                title: "How Much Does It Cost to Sell NFTs?",
                                link: "/costs-to-sell-nfts"
                            }
                        ],
                        color: "#b7f279"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LearnTile, {
                        title: "Buying",
                        numArticles: 3,
                        articles: [
                            {
                                title: "Where to Buy NFTs?",
                                link: "/buy-nfts"
                            },
                            {
                                title: "How to Find NFT Projects Early",
                                link: "/find-nft-projects"
                            },
                            {
                                title: "NFT Collectors vs. Speculators",
                                link: "/collectors-vs-speculators"
                            }
                        ],
                        color: "#068d01"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LearnTile, {
                        title: "What Can You Do?",
                        numArticles: 3,
                        articles: [
                            {
                                title: "What is NFT Farming and How to Earn from it?",
                                link: "/nft-farming"
                            },
                            {
                                title: "How to Earn from NFTs?",
                                link: "/earn"
                            },
                            {
                                title: "How to Make Money From the NFT Industry",
                                link: "/make-money"
                            }
                        ],
                        color: "#f53d4c"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LearnTile, {
                        title: "Security",
                        numArticles: 3,
                        articles: [
                            {
                                title: "What is Escrowed Peer-To-Peer Trading?",
                                link: "/escrowed-trading"
                            },
                            {
                                title: "How to Avoid NFT Scams?",
                                link: "/avoid-scams"
                            },
                            {
                                title: "What Copy & Paste is NOT how NFTs Work",
                                link: "/copy-paste"
                            }
                        ],
                        color: "#1fada5"
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 56119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _primitives__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92902);
/* harmony import */ var next_themes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82010);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1852);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_responsive__WEBPACK_IMPORTED_MODULE_3__);




const LearnHeroSection = ()=>{
    const { theme  } = (0,next_themes__WEBPACK_IMPORTED_MODULE_2__/* .useTheme */ .F)();
    const isMobile = (0,react_responsive__WEBPACK_IMPORTED_MODULE_3__.useMediaQuery)({
        query: "(max-width: 968px)"
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
        as: "section",
        css: {
            marginBottom: "$4",
            width: "100%",
            borderTopLeftRadius: "20px",
            borderTopRightRadius: "20px",
            backgroundPosition: "center center",
            backgroundImage: "linear-gradient(109.6deg, rgb(0, 0, 0) 11.2%, $primary13 91.1%), url('/images/heroSectionBanner.png')",
            "@xs": {
                display: "block"
            },
            "@bp1000": {
                display: "flex"
            }
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                direction: "column",
                css: {
                    flex: 1,
                    "@xs": {
                        padding: "64px 24px"
                    },
                    "@lg": {
                        padding: "80px 64px"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                        css: {
                            color: "$whiteA12",
                            lineHeight: 1.2
                        },
                        style: {
                            "@initial": "h3",
                            "@lg": "h1"
                        },
                        children: [
                            "NFTEarth ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            " Education is Live!"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                        style: {
                            "@initial": "subtitle2",
                            "@lg": "subtitle1"
                        },
                        css: {
                            lineHeight: 1.5,
                            width: "100%",
                            marginTop: "$3",
                            "@lg": {
                                width: "50%"
                            },
                            color: "$whiteA12"
                        },
                        children: "Learn about NFTs, hone your skills and knowledge about NFTs before the next bull run to not miss the opportunity!"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                css: {
                    // backgroundImage: `url(/images/LearnNFT.png)`,
                    // backgroundPosition: 'center',
                    // backgroundRepeat: 'no-repeat',
                    flex: 0.6,
                    "@xs": {},
                    "@md": {}
                },
                children: isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/images/LearnNFT.png",
                    style: {
                        marginTop: "-50px",
                        height: "200px"
                    }
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/images/LearnNFT.png",
                    style: {
                        marginTop: "-50px"
                    }
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LearnHeroSection);


/***/ }),

/***/ 26228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_primitives__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92902);
/* harmony import */ var components_Layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51943);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82731);
/* harmony import */ var components_learn_nfts_LearnGrid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91269);
/* harmony import */ var components_learn_nfts_LearnHeroSection__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56119);






const EducationPage = ()=>{
    const isMounted = (0,hooks__WEBPACK_IMPORTED_MODULE_3__/* .useMounted */ .s4)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                css: {
                    p: 24,
                    height: "100%",
                    "@bp800": {
                        p: "$6"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_learn_nfts_LearnHeroSection__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                        css: {
                            marginBottom: "$4",
                            "@xs": {
                                textAlign: "center"
                            },
                            "@lg": {
                                textAlign: "left"
                            }
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                            style: {
                                "@initial": "h5",
                                "@md": "h3"
                            },
                            children: "Choose what you would like to learn about NFTs"
                        })
                    }),
                    isMounted && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_learn_nfts_LearnGrid__WEBPACK_IMPORTED_MODULE_4__/* .LearnGrid */ .s, {})
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                justify: "between",
                css: {
                    borderTop: "1px solid $gray7",
                    borderStyle: "solid",
                    p: "$2",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: 36,
                    "@bp600": {
                        flexDirection: "row",
                        gap: 0
                    }
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                    justify: "between",
                    css: {
                        p: "10px 60px",
                        alignItems: "center",
                        "@xs": {
                            display: "block",
                            textAlign: "center"
                        },
                        "@bp1000": {
                            display: "flex",
                            textAlign: "left"
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                            css: {
                                width: "40%",
                                "@xs": {
                                    margin: "auto",
                                    width: "100%"
                                },
                                "@bp1000": {
                                    margin: "0 0",
                                    width: "40%"
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                                    css: {
                                        marginBottom: "$3"
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                                        style: {
                                            "@initial": "h4",
                                            "@lg": "h3"
                                        },
                                        children: "About NFTEarth Education"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                                    style: {
                                        "@initial": "subtitle2",
                                        "@lg": "subtitle1"
                                    },
                                    css: {
                                        marginBottom: "$2"
                                    },
                                    children: "NFTEarth Education is a free knowledge base covering everything you need to know about NFTs, from basic to more advanced topics. Utilize our expertise to get up to speed and feel confident about diving headfirst into the world of NFTs."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: "/images/LearnNFT_book.png",
                                style: {
                                    margin: "auto"
                                }
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (EducationPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7948,8421,1943,9774,2888,179], function() { return __webpack_exec__(19567); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);